import { RadioGroup, Radio } from '@appkit4/react-components';
import useLocale from 'locale/useLocale';
import { NewDeclarationFormValues } from 'pages/SubmissionFormWizard/SubmissionFormWizard';
import { useFormikContext } from 'formik';
import { useAbsenceReasons } from 'contexts/AbsenceReasonsProvider/AbsenceReasonsProvider';
import React, { Fragment, useRef } from 'react';
import useFocusOnRender from 'helpers/useFocusOnRender';
import { renderFurtherInformation } from 'helpers/reasonInformation/ConfigureFurtherInfoString';

export type PlannedReasonStepTwoProps = {
    submissionIdForEditFlow?: string;
};

const PlannedReasonStepTwo = ({
    submissionIdForEditFlow,
}: PlannedReasonStepTwoProps) => {
    const { l } = useLocale();
    const { values, setFieldValue } =
        useFormikContext<NewDeclarationFormValues>();
    const { plannedAbsenceReasons } = useAbsenceReasons();

    const inputRef = useRef<HTMLInputElement>(null);
    useFocusOnRender(inputRef);

    const newSubHeadingText = (
        <>
            {l('_pleaseSelectPlannedCircumstance').split('the applicable')[0]}
            the applicable
            {
                l('_pleaseSelectPlannedCircumstance')
                    .split('the applicable')[1]
                    .split('and specify the relevant date(s)')[0]
            }
            and specify the relevant date(s)
            {
                l('_pleaseSelectPlannedCircumstance')
                    .split('the applicable')[1]
                    .split('and specify the relevant date(s)')[1]
            }
        </>
    );

    return (
        <div>
            <div className="padding-10-top-bottom">
                {submissionIdForEditFlow
                    ? l('_editPleaseSelectPlannedCircumstance')
                    : newSubHeadingText}
            </div>
            <h2 className="ap-typography-heading-s" ref={inputRef}>
                {submissionIdForEditFlow
                    ? l('_editPlannedCircumstance')
                    : values.declarationType}
            </h2>

            <RadioGroup
                defaultValue={''}
                name="reasonForAbsence"
                className="radio-style"
                value={values.reasonForAbsence || ''}
                onChange={(value: React.SetStateAction<string>) => {
                    setFieldValue('reasonForAbsence', value);
                }}
            >
                {plannedAbsenceReasons &&
                    plannedAbsenceReasons.map((plannedAbsenceReason, index) => {
                        if (plannedAbsenceReason?.reason) {
                            const isFirstRadio = index === 0;
                            return (
                                <Fragment key={index}>
                                    <Radio
                                        inputRef={
                                            isFirstRadio ? inputRef : null
                                        }
                                        key={plannedAbsenceReason?.reason}
                                        value={plannedAbsenceReason?.reason}
                                        aria-label={
                                            plannedAbsenceReason?.reason
                                        }
                                    >
                                        <div
                                            className={
                                                plannedAbsenceReason.reason
                                                    ? 'checked-label'
                                                    : ''
                                            }
                                        >
                                            {plannedAbsenceReason?.reason}
                                        </div>
                                    </Radio>
                                    {plannedAbsenceReason.furtherInformation &&
                                    values.reasonForAbsence ===
                                        plannedAbsenceReason.reason ? (
                                        <div className="selected-info">
                                            <p className="checked-label">
                                                <i className="Appkit4-icon icon-information-fill" />
                                                {l('_furtherInformation')}
                                            </p>
                                            <span>
                                                {renderFurtherInformation(
                                                    plannedAbsenceReason?.furtherInformation,
                                                    plannedAbsenceReason?.reason
                                                )}
                                            </span>
                                        </div>
                                    ) : null}
                                </Fragment>
                            );
                        }
                    })}
            </RadioGroup>
        </div>
    );
};

export default PlannedReasonStepTwo;
